import React, { useEffect, useCallback, useRef } from "react";
import styles from "./PopupNotification.module.css";

function PopupNotification({ msg, onClose }) {
  const timer = useRef(null);

  const getTypeStyle = () => {
    switch (msg.type) {
      case "Success":
        return { backgroundColor: "#1ab861", color: "white" };
      case "success":
        return { backgroundColor: "#1ab861", color: "white" };
      case "Warning":
        return { backgroundColor: "#f5c320", color: "white" };
      case "warning":
        return { backgroundColor: "#f5c320", color: "white" };
      case "Error":
        return { backgroundColor: "#e0462b", color: "white" };
      case "error":
        return { backgroundColor: "#e0462b", color: "white" };
      default:
        return { backgroundColor: "#f5c320", color: "white" };
    }
  };

  const getIcon = () => {
    switch (msg.type) {
      case "Success":
        return (
          <>
            {" "}
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
          </>
        );
      case "success":
        return (
          <>
            {" "}
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
          </>
        );
      case "Warning":
        return (
          <>
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
            </svg>
          </>
        );
      case "warning":
        return (
          <>
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
            </svg>
          </>
        );
      case "Error":
        return (
          <>
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
            </svg>
          </>
        );
      case "error":
        return (
          <>
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
            </svg>
          </>
        );
      default:
        return (
          <>
            <svg
              className="w-10 h-10 text-[#ffffff]"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
            </svg>
          </>
        );
    }
  };

  const startTimer = useCallback(() => {
    timer.current = setTimeout(() => {
      onClose();
    }, 6000);
  }, [onClose, timer, msg.type]);

  const clearExistingTimer = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, [timer]);

  useEffect(() => {
    const isWarning = msg?.type?.toLowerCase() === "warning";
    const element = document.getElementById("popupalert");

    if (isWarning) {
      element.classList.remove(`${styles.notification}`);
      element.classList.add(`${styles.warningPersistent}`);
    } else {
      element.classList.add(`${styles.notification}`);
      startTimer();
    }

    return () => clearExistingTimer();
  }, [msg.type, onClose, startTimer, clearExistingTimer]);

  const handleMouseEnter = () => {
    const isWarning = msg?.type?.toLowerCase() === "warning";

    if (!isWarning) {
      document.getElementById("popupalert").classList.remove(`${styles.notification}`);
      clearExistingTimer();
    }
  };

  const handleMouseLeave = () => {
    const isWarning = msg?.type?.toLowerCase() === "warning";

    if (!isWarning) {
      document.getElementById("popupalert").classList.add(`${styles.notification}`);
      startTimer();
    }
  };

  return (
    <>
      <div
        id="popupalert"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`fixed z-[9999] sm:!w-auto w-[400px] flex items-center text-gray-500 rounded-lg bottom-[60px] sm:left-[20px] right-[20px]`}
        style={getTypeStyle()}
        role="alert"
      >
        <div className="flex w-full items-center p-4 sm:flex-col sm:gap-4 sm:justify-center">
          {getIcon()}
          <div className="flex flex-col sm:ms-0 ms-4 sm:text-center">
            <span>แจ้งเตือน</span>
            <span>
              {msg.data ?? (typeof msg === "string" ? msg : "Message")}
            </span>
          </div>
          <div
            className="absolute top-[10px] right-[10px] text-[#ffffff] cursor-pointer"
            onClick={onClose}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
}

export default PopupNotification;
